<template>
  <div class='content'>
    <div class="headBoxTool">
      <div class="rigth-box" v-if="blankFlage == 3">
        <span class="icon green"><i class="icon-xiaochengxu"></i></span>
        <div class="text-box">
          <div class="text1">管理小程序模板</div>
          <div class="text2">您可以创建并自定义页面模板，或选择默认模板，复制模板链接至公众号菜单栏，可作为用户常用入口（模板内保险产品均为机构专属投保地址）</div>
        </div>
      </div>
      <div class="rigth-box" v-else>
        <span class="icon blue"><i class="icon-h5duan"></i></span>
        <div class="text-box">
          <div class="text1">管理H5页面模板</div>
          <div class="text2">您可以创建并自定义页面模板，或选择默认模板，复制模板链接至公众号菜单栏，可作为用户常用入口（模板内保险产品均为机构专属投保地址）</div>
        </div>
      </div>
      <div class="btnList">
        <el-button class="backBtn" type="primary" @click="goback()">返回</el-button>
      </div>
    </div>
    <templateList ref="templateListRef" :blankFlage="blankFlage"></templateList>
  </div>
</template>
<script>
import templateList from './component/templateList.vue'
export default {
  data: () => ({
    blankFlage: '',
  }),
  components: { templateList },
  created() {
    this.blankFlage = this.$route.query.websiteType
  },
  methods: {
    goback() {
      this.$router.push('/myweb')
    },
  },
}
</script>
<style lang='scss' scoped>
.content {
  background: #ffffff;
  height: 100vh;
  .headBoxTool {
    padding: 25px 30px;
    display: flex;
    justify-content: space-between;
    min-width: 1020px;
    .rigth-box {
      display: flex;
      .icon {
        vertical-align: middle;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        font-size: 30px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
      }
      .blue {
        background: #cae1ff;
        color: #409eff;
      }
      .green {
        background: #ebffea;
        color: #24c453;
      }
      .text-box {
        margin-left: 5px;
        .text1 {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-bottom: 10px;
          margin-top: 3px;
        }
        .text2 {
          font-size: 14px;
          color: #666;
        }
      }
    }
    .btnList {
      .backBtn {
        background: #fd9201;
        color: #ffffff;
        width: 80px;
        height: 30px;
        padding: 0;
      }
      .bg {
        background: #ffffff;
        color: #fd9201;
      }
      .btn-style {
        width: 152px;
        height: 30px;
        padding: 0;
      }
    }
  }
}
</style>